import { Component, OnInit, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ActivatedRoute } from '@angular/router';

import Swal from 'sweetalert2';

import { AuthenticationService } from 'app/auth/service';
import { BudgetService } from 'app/service/budget/budget.service';
import { DomainService } from 'app/service/domain/domain.service';
import { OperationService } from 'app/service/operation/operation.service';
import { ProofComponent } from '../../operation/proof/proof.component';
import { AlertService } from 'app/service/alert/alert.service';

@Component({
  selector: 'app-budget-cash-payement',
  templateUrl: './budget-cash-payement.component.html',
  styleUrls: ['./budget-cash-payement.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BudgetCashPayementComponent implements OnInit {

  currentUser = Object.freeze(this.authenticationService.currentUserValue);

  @ViewChild(ProofComponent) child !: any;
  @ViewChildren(ProofComponent)
  parseFloat = parseFloat

  public currentBudget
  public budgets
  public domains
  public subdomains

  proofExist = false

  public createPayementOperationForm: FormGroup;
  public payementOperationSubmitted = false
  public loadingSubmitCashPayement = false

  constructor(
    private authenticationService: AuthenticationService,
    private budgetService: BudgetService,
    private domainService: DomainService,
    private operationService: OperationService,
    private _formBuilder: FormBuilder,
    private alertService: AlertService,
    private route: ActivatedRoute
  ) { }

  // convenience getter for easy access to payement operation form fields
  get p_o() {
    return this.createPayementOperationForm.controls;
  }

  submitPayementOperation(res) {
    if (res.value == true) {
      this.loadingSubmitCashPayement = true
      let label = 'cash_payement'
      if (this.p_o.budget_receiver.value != null && this.p_o.budget_receiver.value != '') {
        label = 'cash_transfert'
      }
      let cash_amount = this.currentBudget.cash_amount - this.p_o.amount.value
      this.operationService.cashPayement(this.currentUser.id, null, this.currentBudget.id, this.p_o.budget_receiver.value, label, this.p_o.title.value, this.p_o.note.value, this.p_o.reference.value, null, this.p_o.domain.value, null, null, this.p_o.operation_date.value, this.p_o.amount.value, cash_amount, this.currentBudget.bank_amount)
        .subscribe({
          next: (operation) => {
            this.child.submitProof(operation)
            this.loadingSubmitCashPayement = false
            this.payementOperationSubmitted = false
          },
          error: (e) => {
            this.loadingSubmitCashPayement = false
            this.payementOperationSubmitted = false
            console.error(e)
          }
        });
    }
  }

  confirmOperation() {
    this.payementOperationSubmitted = true
    if (this.createPayementOperationForm.invalid) {
      return
    } else {
      if (this.proofExist) {
        console.log('yes')
        Swal.fire({
          title: 'Are you sure you want to go through this transaction ?',
          text: `${this.p_o.amount.value} DT, will be debited from your budget !`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#7367F0',
          cancelButtonColor: '#E42728',
          confirmButtonText: 'Yes, commit it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-secondary ml-1'
          }
        }).then(res => this.submitPayementOperation(res));
      } else {
        this.alertService.errorAlert('You cant commit this yet', 'You have to import at least one justification file');
      }
    }
  }

  handleProof(e) {
    if (!e) {
      this.proofExist = false
    } else {
      this.proofExist = true
    }
  }

  getDomains(): void {
    this.domainService.getAll()
      .subscribe({
        next: (data) => {
          this.domains = data
          this.subdomains = this.domains.flatMap(item => item.subdomains)
        },
        error: (e) => console.error(e)
      });
  }

  getBudgets(): void {
    this.budgetService.getAll()
      .subscribe({
        next: (data) => {
          this.budgets = data
        },
        error: (e) => console.error(e)
      });
  }

  getBudgetData(): void {
    let id = this.route.snapshot.paramMap.get('id');
    this.budgetService.getBudget(id)
      .subscribe({
        next: (data) => {
          this.currentBudget = data;
        },
        error: (e) => console.error(e)
      });
  }

  ngOnInit(): void {
    this.getBudgetData();
    this.getBudgets()
    this.getDomains();

    //payement operation
    this.createPayementOperationForm = this._formBuilder.group({
      budget_receiver: [''],
      title: ['', Validators.required],
      note: [''],
      reference: ['', Validators.required],
      domain: ['', Validators.required],
      operation_date: [''],
      amount: ['', Validators.required],
    });
  }

}